import React from "react";

export const quoteColumns = [
  {
    accessorKey: "submission_number",
    header: "Submission Number",
    cell: ({ getValue }) => <div>{getValue() || "N/A"}</div>
  },
  {
    accessorKey: "dot_number",
    header: "DOT Number",
    cell: ({ row }) => <div>{row.original["DOT Number"] || "N/A"}</div>,
  },
  {
    accessorKey: "company",
    header: "Company",
    cell: ({ getValue }) => <div>{getValue() || "N/A"}</div>,
  },
  {
    accessorKey: "effective_date",
    header: "Effective Date",
    cell: ({ getValue }) => <div>{getValue() || "N/A"}</div>,
  },
  {
    accessorKey: "carrier",
    header: "Carrier",
    cell: ({ getValue }) => <div>{typeof getValue() === 'string' ? getValue() || "N/A" : getValue().join(', ') || "N/A"}</div>,
  },
  {
    accessorKey: "premium",
    header: "Premium",
    cell: ({ row }) => {
      const premium = row.original.premium;
      return <div>{premium || "$0.00"}</div>;
    },
  },
  {
    accessorKey: "Drivers",
    header: "Drivers",
    cell: ({ getValue }) => <div>{getValue() || "0"}</div>,
  },
  {
    accessorKey: "Vehicles",
    header: "Vehicles",
    cell: ({ getValue }) => <div>{getValue() || "0"}</div>,
  },
  {
    accessorKey: "Trailers",
    header: "Trailers",
    cell: ({ getValue }) => <div>{getValue() || "0"}</div>,
  },
  {
    accessorKey: "Created At",
    header: "Created At",
    cell: ({ getValue }) => <div>{getValue() || "N/A"}</div>,
  },
  {
    accessorKey: "status",
    header: "Status",
    cell: ({ getValue }) => {
      const status = getValue();
      const getStatusColor = (status) => {
        const statusMap = {
          created: "bg-gray-100 text-gray-800",
          submitted: "bg-blue-100 text-blue-800",
          processing: "bg-orange-100 text-orange-800",
          declined: "bg-red-100 text-red-800",
          inactive: "bg-gray-100 text-gray-600",
          "requested bind": "bg-purple-100 text-purple-800",
          active: "bg-green-100 text-green-800",
          sketch: "bg-gray-100 text-gray-800",
          validation_error: "bg-red-100 text-red-800",
          sent: "bg-blue-100 text-blue-800",
        };
        return statusMap[status] || "bg-gray-100 text-gray-800";
      };

      return (
        <span className={`px-2 py-1 rounded-md font-medium ${getStatusColor(status)}`}>
          {status}
        </span>
      );
    },
  },
];